// Thin fetch wrapper for the Work tracker JSON endpoints. Every write carries
// the Rails CSRF token; every non-2xx becomes an Error with the server's
// message and status so callers can tell a 409 (edit lock) from a failure.

const csrfToken = () => document.querySelector('meta[name="csrf-token"]')?.content;

export class ApiError extends Error {
  constructor(status, body) {
    const errors = body && body.errors ? body.errors.join(', ') : '';
    const locked = body && body.locked_by ? `${body.locked_by} is editing` : '';
    super(errors || locked || `Request failed (${status})`);
    this.status = status;
    this.body = body;
  }
}

const request = async (method, url, payload) => {
  const response = await fetch(url, {
    method,
    headers: { Accept: 'application/json', 'Content-Type': 'application/json', 'X-CSRF-Token': csrfToken() },
    credentials: 'same-origin',
    body: payload === undefined ? undefined : JSON.stringify(payload),
  });
  const text = await response.text();
  const body = text ? JSON.parse(text) : null;
  if (!response.ok) throw new ApiError(response.status, body);
  return body;
};

const BASE = '/admin/tasks';

export const api = {
  load: () => request('GET', `${BASE}.json`),
  createTask: (attrs) => request('POST', `${BASE}.json`, { admin_task: attrs }),
  updateTask: (id, attrs, extra = {}) => request('PATCH', `${BASE}/${id}.json`, { admin_task: attrs, ...extra }),
  deleteTask: (id) => request('DELETE', `${BASE}/${id}.json`),
  reorder: (ids) => request('PATCH', `${BASE}/reorder.json`, { ids }),
  lock: (id) => request('POST', `${BASE}/${id}/lock.json`),
  unlock: (id) => request('DELETE', `${BASE}/${id}/lock.json`),
  addComment: (taskId, body) => request('POST', `${BASE}/${taskId}/notes.json`, { admin_task_note: { body } }),
  deleteComment: (taskId, id) => request('DELETE', `${BASE}/${taskId}/notes/${id}.json`),
  createEvent: (attrs) => request('POST', '/admin/calendar_events.json', { admin_calendar_event: attrs }),
  updateEvent: (id, attrs) => request('PATCH', `/admin/calendar_events/${id}.json`, { admin_calendar_event: attrs }),
  deleteEvent: (id) => request('DELETE', `/admin/calendar_events/${id}.json`),
};
